export default {
    routes: [
        {
            // Moved into Settings ▸ Usage and billing. Kept as a redirect
            // because the old address is in people's bookmarks, in the links
            // they were sent, and in the return URL of any Stripe session
            // opened before the move.
            //
            // The **function** form, not an object: an object redirect drops
            // the query, and both `?issued=` (the invoice a purchase just
            // raised) and `?invoice=&session_id=` (Stripe coming back) ride on
            // it. Losing them turns a successful payment into a blank screen.
            path: 'billing',
            redirect: to => ({ name: 'settings-billing-invoices', query: to.query })
        }
    ]
};
